const ADMIN_ROLES = ['admin', 'localAdmin'];

export default function isAdmin(role?: string | null): boolean {
  return !!role && ADMIN_ROLES.includes(role);
}
